import { formatChartValue, getNiceChartStep } from '../../utils/formatters'

export default function BarChart({ max, procedures }) {
  const maxRevenue = Math.max(max, ...procedures.map((item) => item.revenue), 0)
  const tickStep = getNiceChartStep(maxRevenue)
  const chartMax = tickStep * 5
  const ticks = Array.from({ length: 6 }, (_, index) => chartMax - tickStep * index)

  return (
    <div className="grid grid-cols-[32px_minmax(0,1fr)] gap-3 sm:grid-cols-[42px_minmax(0,1fr)] sm:gap-4">
      <div className="grid h-[150px] grid-rows-6 text-right text-[10px] font-bold text-[#5A5147] sm:h-[200px] sm:text-xs">
        {ticks.map((tick) => (
          <span key={tick}>{formatChartValue(tick)}</span>
        ))}
      </div>
      <div className="relative">
        <div className="absolute inset-x-0 top-0 grid h-[150px] grid-rows-6 sm:h-[200px]">
          {Array.from({ length: 6 }).map((_, index) => (
            <div className="border-t border-[#E5DED3]" key={index} />
          ))}
        </div>
        <div className="relative grid h-[150px] grid-cols-5 items-end gap-2 border-l border-[#DDD7CE] pl-4 sm:h-[200px] sm:gap-4 sm:pl-6">
          {procedures.slice(0, 5).map((item, index) => {
            const height = item.revenue ? Math.max(6, (item.revenue / chartMax) * (window.innerWidth < 640 ? 120 : 170)) : 0
            const colors = ['#8A6819', '#7A5963', '#5A5147', '#BCAFA0', '#D8D2C8']
            return (
              <div className="flex h-full flex-col items-center justify-end" key={`${item.procedure}-bar`}>
                <span className="mb-1 text-[9px] font-bold text-[#5A5147] sm:mb-2 sm:text-[10px]">
                  {formatChartValue(item.revenue)}
                </span>
                <div
                  className="w-full max-w-[32px] rounded-t-lg sm:max-w-[42px]"
                  style={{ height: `${height}px`, background: colors[index % colors.length] }}
                />
              </div>
            )
          })}
        </div>
        <div className="grid grid-cols-5 gap-2 pl-4 pt-2 text-center text-[10px] font-bold text-[#5A5147] sm:gap-4 sm:pl-6 sm:pt-3 sm:text-xs">
          {procedures.slice(0, 5).map((item) => (
            <span className="truncate" key={`${item.procedure}-label`}>
              {item.procedure}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}
